module.exports = __webpack_public_path__ + "static/media/Slider3_Rezeptwelten.b46d5c22.jpg";